// initial state
import axios from "axios";

const state = () => ({
    clipboard : []
})

// getters
const getters = {
    getClipboard: (state) => {
        return state.clipboard;
    }
}

// actions
const actions = {

}

// mutations
const mutations = {
    setClipboard (state, clipboard) {
        state.clipboard = clipboard
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
